import { createReducer } from 'redux-act';

import * as actions from './actions';

export default createReducer({
  [actions.setRequiredBadges]: (state, payload) => R.pipe(
    R.assocPath(['form', 'required_badge_count'], payload),
    R.dissocPath(['errors', 'required_badge_count']),
  )(state),
  [actions.setLevelName]: (state, payload) => R.pipe(
    R.assocPath(['form', 'name'], payload),
    R.dissocPath(['errors', 'name']),
    ({ form, levels, ...rest }) => ({
      form,
      ...rest,
      levels: R.adjust(
        R.always(form),
        R.findIndex(R.pipe(R.prop('uuid'), R.equals(form.uuid)), levels),
        levels
      )
    })
  )(state),
  [actions.setLevels]: (state, payload) => R.assoc('levels', payload, state),
  [actions.setErrors]: (state, payload) => R.assoc('errors', payload, state),
  [actions.setSelectedBadges]: (state, payload) => R.assoc('selectedBadges', payload, state),
  [actions.setIsSaving]: (state, payload) => R.assoc('isSaving', payload, state)
});
